export default __webpack_public_path__ + "static/media/raw-color-coil.180fe317.jpg";